// extracted by mini-css-extract-plugin
export default {"position":"ProfileMenuItem_position__Gz5g5"};